import { render } from "./PasswordBox.vue?vue&type=template&id=0c9fc2c4"
import script from "./PasswordBox.vue?vue&type=script&lang=js"
export * from "./PasswordBox.vue?vue&type=script&lang=js"
script.render = render

export default script